import React, { useReducer } from "react";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import clsx from "clsx";

// Custom.
import { GroupUserEditProps } from "./global";
import { getContactName, reducer } from "@vocollege/app/dist/modules/VoHelpers";
import { useStyles } from "./styles";
import { FormFieldContentListItem } from "@vocollege/components/dist/Form";
import ContentList from "@vocollege/components/dist/Form/fields/ContentList";
import I18n from "@vocollege/app/dist/modules/Services/I18n";

const initialState = {
  groupRoles: [],
};

const GroupUserEdit: React.FC<GroupUserEditProps> = (props) => {
  const { user, onClose, onSave } = props;
  const classes = useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);

  // Methods.

  const handleSave = () => {
    if (!onSave) {
      return;
    }
    let changedUser = { ...user };
    changedUser.groupRoles = [...state.groupRoles];
    onSave(changedUser);
  };

  return (
    <Dialog
      onClose={onClose}
      open={Boolean(user)}
      classes={{ paper: classes.groupUsersEditPaper }}
    >
      <DialogTitle>{`${getContactName(user)} | ${user.email}`}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ContentList
              name="roles"
              label={I18n.get.misc.roles}
              dialog={{ types: ["group_role"] }}
              items={user.groupRoles}
              renderItemTitle={(item: any) => item.label || item.title}
              onChange={(items: FormFieldContentListItem[]) =>
                dispatch({ key: "groupRoles", values: items })
              }
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions classes={{ root: classes.groupUsersEditActionsRoot }}>
        <Button onClick={onClose} color="secondary">
          {I18n.get.actions.cancel}
        </Button>
        <Button
          onClick={handleSave}
          color="secondary"
          variant="contained"
          // disabled={saveDisabled || loading}
          className={clsx("vo-global__actions-button-confirm", {
            // "vo-global__actions-loading": updateLoading,
          })}
          // disableFocusRipple={updateLoading}
        >
          <span className="vo-global__actions-button-confirm-label">
            {I18n.get.actions.save}
          </span>
          {/* {updateLoading && (
        <CircularProgress
          className="vo-global__actions-button-create-loading"
          color="inherit"
          size={25}
        />
      )} */}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupUserEdit;
